<template>
<el-form :model="ruleForm" :rules="rules" ref="ruleForm" :label-position="'top'">

    <label v-if="listDates.length==0">Fechas de ingreso* </label>
    <div class="d-flex border text-center p-2 rounded bg-danger text-white" v-if="listDates.length==0" style="width: 100px; line-height:1.2">
        <span>No tenemos fechas disponibles</span>
    </div>
    <el-form-item v-else prop="date_booking" label="Fechas de ingreso">
        <el-radio-group v-model="ruleForm.date_booking" class=" d-flex" @change="getPlanes">
            <div v-for="(item, index) in listDates" :key="index" class="plan">
                <label class="option mb-2 p-2 pr-4 pt-3 pb-0 border mr-2">
                    <span class="option-control">
                        <span class="radio">
                            <el-radio :label="item.startdate"></el-radio>
                        </span>
                    </span>
                    <span class="option-label w-100 mr-1">
                        <span class="option-head">
                            <div class="option-title mb-1">{{item.startdate | moment("LL")}}</div>
                        </span>
                    </span>
                </label>
            </div>
        </el-radio-group>
    </el-form-item>


    <!--<el-form-item label="Fecha para acampar" prop="date_booking"> v-html="item.startdate"
        <el-date-picker type="date" placeholder="seleccione"
        v-model="ruleForm.date_booking" @change="getPlanes" style="width: 100%;"></el-date-picker>
    </el-form-item>-->

    <el-form-item label="Selecciona un club zonal" prop="seat">
        <el-select v-model="ruleForm.seat" placeholder="Seleccione" filterable class="w-100" @change="getPlanes">
            <el-option v-for="item in coverage" :key="item.idseat" :label="item.name" :value="item.idseat" style="width:100%;"></el-option>
        </el-select>
    </el-form-item>

    <!--<label class="col-form-label text-left">Seleccione el tipo de espacio</label>-->
    <el-form-item prop="schedul" label="Seleccionar el espacio">
        <el-radio-group v-model="ruleForm.schedul" class="w-100">
            <div v-for="item in listScheduls" :key="item.idschedule" class="plan">

                <label class="option mb-2 p-2 pr-4 pt-3 pb-0 border">

                    <span class="option-control mt-2">
                        <span class="radio">
                            <el-radio :label="item.idschedule"></el-radio>
                        </span>
                    </span>
                    <span class="option-label border-right w-100 mr-1">
                        <span class="option-head">
                            <div class="option-title mb-1" v-html="item.title"></div>
                        </span>
                        <span class="option-body pt-1" v-html="item.schedule"></span>
                    </span>
                    <div class="d-flex align-items-center">
                        <div class="symbol symbol-circle symbol-success mx-2">
                            <img alt="Serpar" :src="'https://th.bing.com/th/id/R.392915bff69b040a9d1dfff82386d7f8?rik=PvRoMJTKsR50Cg&pid=ImgRaw&r=0'">
                        </div>
                    </div>
                </label>
            </div>
        </el-radio-group>
    </el-form-item>


    <button class="btn outline-btn mb-3 mt-3 ml-2" @click.prevent="atras">Atras</button>
    <button class="btn outline-btn mb-3 mt-3 ml-2" @click.prevent="submitForm('ruleForm')">Siguiente</button>
</el-form>
</template>

<script>
//libraries
import moment from 'moment';

//services
//import services from "@/services/services.service"
import scheduls from "@/services/scheduls.service"

export default {
    props: {
        product: {
            type: Object,
            required: true,
            default: {}
        },
        coverage: {
            type: Array,
            required: true,
            default: []
        }
    },

    data() {
        var checkPlan = (rule, value, callback) => {
            if (value == null)
                return callback(new Error(`Falta seleccionar el tipo de espacio`));
            else
                callback();
        }

        return {
            listScheduls: [],
            listDates: [],
            ruleForm: {
                seat: null,
                seat_name: null,
                schedul: null,
                schedul_name: null,
                date_booking: null,
                limit: null
            },
            rules: {
                seat: [{
                    required: true,
                    message: 'Falta seleccionar el club o parque',
                    trigger: ['change','blur']
                }],
                schedul: [{
                    validator: checkPlan,
                    trigger: ['change', 'blur']
                }],
                date_booking: [{
                    required: true,
                    message: 'Falta seleccionar fecha de reserva',
                    trigger: ['change']
                }]
            },
        }
    },
    methods: {
        async getDatesVisita() {
            this.$emit("update:loading", true)
            await scheduls.getDates_Available({product: this.product.idproduct}).then((res) => {
                this.listDates = res.data
            }).catch((error) => {
                alert('Lo sentimos, nuestra plataforma esta presentando inconvenientes, intentalo más tarde')
                this.$emit("update:loading", false)
            }).finally(() => {
                this.$emit("update:loading", false)
            })

        },
        async getPlanes() {
            this.$emit("update:loading", true)
            this.ruleForm.schedul = null
            await scheduls.getFace({
                a: this.product.idproduct,
                b: this.ruleForm.seat,
                c:moment(this.ruleForm.date_booking).format("YYYY-MM-DD")
            }).then((res) => {
                this.listScheduls = res.data
            }).catch((err) => {
                alert('Lo sentimos, nuestra plataforma esta presentando inconvenientes, intentalo más tarde')
                this.$emit("update:loading", false)
            }).finally(() => {
                this.$emit("update:loading", false)
            })
        },
        async checkAforo() {
            this.$emit("update:loading", true)
            await scheduls.getAforo_Date_visit({
              a: this.ruleForm.seat, b: this.ruleForm.schedul, c:moment(this.ruleForm.date_booking).format("YYYY-MM-DD")
            }).then((response) => {
                if(!response.data.status)
                  return alert(response.data.message)

                let ar = this.coverage.filter(param => param.idseat === this.ruleForm.seat);
                this.ruleForm.seat_name = Object.assign({}, ...ar).name;

                let br = this.listScheduls.filter(param => param.idschedule === this.ruleForm.schedul);
                this.ruleForm.schedul_name = Object.assign({}, ...br).title;
                this.ruleForm.limit = parseInt(Object.assign({}, ...br).location)


                this.$emit("update:number", 2)
                this.$emit("update:loading", false)
                this.$emit("getWizard1", this.ruleForm)
            }).catch((error) => {
                alert('Lo sentimos, nuestra plataforma esta presentando inconvenientes, intentalo más tarde')
                this.$emit("update:loading", false)
            }).finally(() => {
                this.$emit("update:loading", false)
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid)
                    this.checkAforo()
            })
        },
        atras() {
            this.$emit("update:number", 0)
        }
    },
    created() {
        this.getDatesVisita()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/camping/wizard1.vue